import {authActions} from "../../store/actions/authAction";
import {metricFilterActions} from "../../store/actions/metricFilterAction";
import {columnActions} from "../../store/actions/columnAction";
import {workspaceActions} from "../../store/actions/workspaceAction";
import {jwtDecode} from "jwt-decode";

export default async function authMiddleware(store) {
    let accessToken = localStorage.getItem("access-token");
    if (accessToken !== undefined && accessToken !== "" && accessToken !== null) {
        try {
            const payload = jwtDecode(accessToken);
            const currentTime = Math.floor(Date.now() / 1000);
            if (payload.exp && payload.exp >= currentTime) {
                // Dispatch sequentially
                await store.dispatch(authActions.updateAuthenticationStatus(payload));
                await store.dispatch(authActions.loadUserSettings());
                await store.dispatch(authActions.fetchSubscription());
                await store.dispatch(workspaceActions.getUserWorkspaces());
                await store.dispatch(columnActions.getReportColumns());
                await store.dispatch(metricFilterActions.setMetricFiltersFromCache());
            }
        } catch (err) {
            console.error("Auth error:", err);
        }
    }
}